module.exports = {
    sessionKey: 'userSessionKey',
    guestToken: 'guestToken',
    userLanguageExceptedRoute: 'userLanguageExceptedRoute',
    failedConfirmSignupMessage: 'failedConfirmSignupMessage',
    verifyEmailConfirmationCode: 'verifyEmailConfirmationCode',
    resetPasswordCode: 'resetPasswordCode',
    resetPasswordEmail: 'resetPasswordEmail',
}